import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/Header';

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const navItems = [
    { path: '/admin/stats', icon: 'bar_chart', label: '利用実績' },
    { path: '/admin/users', icon: 'group', label: 'ユーザー管理' },
    { path: '/admin/shares', icon: 'send', label: '共有履歴' },
    { path: '/admin/logs', icon: 'receipt_long', label: '監査ログ' },
    { path: '/admin/announcements', icon: 'campaign', label: 'お知らせ設定' },
  ];

  return (
    <div className="page-wrapper">
      <Header />

      <div className="flex" style={{ maxWidth: 'var(--max-width)', margin: '0 auto', padding: 'var(--space-5)' }}>
        {/* Desktop Sidebar */}
        <nav className="admin-sidebar" style={{ marginRight: 'var(--space-5)' }}>
          <h2 className="admin-sidebar__title">管理画面</h2>
          <ul className="admin-sidebar__nav">
            {navItems.map(({ path, icon, label }) => (
              <li key={path}>
                <button
                  onClick={() => navigate(path)}
                  className={`admin-sidebar__btn ${isActive(path) ? 'admin-sidebar__btn--active' : ''}`}
                >
                  <span className="material-symbols-outlined icon-sm">{icon}</span> {label}
                </button>
              </li>
            ))}
          </ul>

          <div style={{ marginTop: 'var(--space-8)', paddingTop: 'var(--space-5)', borderTop: '1px solid var(--color-border-light)' }}>
            <button
              onClick={() => navigate('/files')}
              className="btn btn--secondary btn--sm w-full mt-6"
            >
              ← 通常画面に戻る
            </button>
          </div>
        </nav>

        <main style={{ flex: 1 }}>
          {/* Mobile Nav - shown only on small screens */}
          <div className="admin-mobile-nav">
            {navItems.map(({ path, icon, label }) => (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={`btn btn--sm ${isActive(path) ? 'btn--primary' : 'btn--secondary'}`}
                style={{ whiteSpace: 'nowrap' }}
              >
                <span className="material-symbols-outlined icon-sm">{icon}</span> {label}
              </button>
            ))}
          </div>

          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
